module.exports = __webpack_public_path__ + "img/microscopes.de5bb106.png";